import router from "next/router";

const defaultResponse = { data: undefined, loading: false, error: false };

const tokenHandler = async (
  userId: string,
  apiFunc: (args: any) => any,
  args: { [key: string]: any }
) => {
  if (!userId) return defaultResponse;
  const response = await apiFunc(args);

  //error code: 401 (same as backend)
  if (response.status === 401) {
    // 로그아웃
    // 이미 로그아웃 페이지라면 이동하지 않게 하자
    if (router.pathname !== "/logout") router.push("/logout");
  }
  return response;
};

export { tokenHandler };
